import React, { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useTermsAndConditionsModal } from '@/feature/terms-and-conditions/components/TermsAndConditionModalProvider';
import { useHasUserAcceptedProductTerms } from '@/feature/terms-and-conditions/hooks/use-has-user-accepted-product-terms';
import { useActiveWallet } from '@/hooks/use-active-wallet';
import { useFormatCurrency } from '@/hooks/use-format-currency';
import { SocialCurrency, useSocialCurrencyStore } from '@/hooks/use-social-currency';

import { BalanceButton } from './BalanceButton';
import { SocialCurrencyActiveIcon } from './SocialCurrencyActiveIcon';
import { Box } from './lib/components';
import { ds } from './lib/design.system';

export const SocialWalletBalanceButton = () => {
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);
    const navigation = useNavigation();
    const { wallets } = useActiveWallet();
    const coinsBalance = wallets.sweeps.COINS?.total || 0;
    const cashBalance = Number(wallets.sweeps.CASH?.real_amount) + Number(wallets.sweeps.CASH?.bonus_amount) || 0;
    const balance = activeCurrency === SocialCurrency.CASH ? cashBalance : coinsBalance;

    const { formatCurrency } = useFormatCurrency();

    const { isAccepted: hasAcceptedProductTerms } = useHasUserAcceptedProductTerms();
    const { showTermsAndConditionsModal } = useTermsAndConditionsModal();

    const showTncSheet = useCallback(() => {
        showTermsAndConditionsModal({
            onSuccess: () => {
                navigation.navigate('DepositStack', { screen: 'CoinPackageScreen' });
            },
        });
    }, [navigation, showTermsAndConditionsModal]);

    return (
        <BalanceButton
            leftIcon={
                <Box mr={'s8'}>
                    <SocialCurrencyActiveIcon />
                </Box>
            }
            textColor={balance === 0 ? ds.colorToken.text.danger : ds.colorToken.text.primary}
            balance={formatCurrency(balance)}
            onPress={() => {
                hasAcceptedProductTerms
                    ? navigation.navigate('DepositStack', { screen: 'CoinPackageScreen' })
                    : showTncSheet();
            }}
        />
    );
};
